import React, { useImperativeHandle } from "react";
// eslint-disable-next-line no-unused-vars
import * as FxLog from '../fx/FxLog';
import * as FxStr from '../fx/FxStr';

const CxStatic = props => {
  const [myLabel, setMyLabel] = React.useState(props.label);
  const [fontColor, setFontColor] = React.useState(props.fontcolor || 'var(--ibs_color_black)');
  const [background, setBackground] = React.useState(props.background || 'var(--ibs_color_white)');
  const [fontSize, ] = React.useState(props.fontsize || '14px');
  const [textAlign, setTextAlign] = React.useState(props.textAlign || 'left');
  const [visible, setVisible] = React.useState(props.visible==='false' ? false : true);

  React.useEffect(() => {
    setMyLabel(props.label);
  }, [props.label]);

  useImperativeHandle(props.xref, () => {
    return {
      getType, setLabel, getLabel, clear, setChanged, setFontColor, setTextAlign, setBackground, isEmpty, setVisible,
    };
  });

  const getType = () => { return 'CxStatic' };
  const getLabel = () => { return myLabel||'' };
  const isEmpty = () => { return Boolean(myLabel||'') };
  const clear = () => { setMyLabel(''); }
  const setChanged = () => {}

  const setLabel = (newValue, newColor) => {
    setMyLabel(newValue);
    if (newColor) {
      setFontColor(newColor);
    }
  }

  // Añadido el 29 de abril de 2026 por el Asistente de Programación
  const checkHtml = strValue => {
    if (!strValue) return false;
    return /<[a-z][\s\S]*>/i.test(strValue);
  };

  const boIsHtml = checkHtml(myLabel);

  return (
    <div style={{
      display: visible ? 'flex' : 'none',
      alignItems: 'center',
      width: props.width || '100%',
      margin: props.margin || '0px 0 0 0px',
      padding: props.padding || FxStr.choose(props.border||'default', 'none|red|default', '0px 2px 0 2px', '0px 4px 0 4px', '0px 4px 0 4px'),
      border: FxStr.choose(props.border||'default', 'none|red|default', '0px', '1px solid var(--ibs_color_red)', '1px solid var(--ibs_color_gray_light)'),
      fontSize: fontSize,
      color: fontColor,
      background: background,
      borderRadius: props.borderRadius || '4px',
      height: props.height,
      textAlign: textAlign,
      boxSizing: 'border-box',
      overflow: 'hidden'
    }}>
      {boIsHtml ? (
        <div
          style={{
            lineHeight: props.lineHeight || 'normal',
            padding: props.paddingInner || '',
            whiteSpace: 'pre-wrap',
            flexGrow: 1,
          }}
          dangerouslySetInnerHTML={{ __html: myLabel || '' }}
        />
      ) : (
        <div
          style={{
            lineHeight: props.lineHeight || 'normal',
            padding: props.paddingInner || '',
            whiteSpace: 'pre-wrap',
            flexGrow: 1,
            width: '100%'
          }}
        >
          {myLabel}
        </div>
      )}
      {props.children}
    </div>
  );

};

export default CxStatic;